// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e9aeba0d","455":"9556cc7f","977":"73380ef0"}[chunkId] + ".chunk.js";
};